import React from "react";
import { AvatarGroup, OverflowingTypography, Stack, ThumbnailAvatar } from ".";
import { bigGeoLogoPng, discordLogoPng } from "../icons";
export const DiscordIntegrationCard = () => {
    return (React.createElement(Stack, { gap: 2, sx: {
            padding: 3,
            backgroundColor: (theme) => theme.palette.background.main,
            borderRadius: (theme) => theme.radius.xs3,
            border: 1,
            borderColor: (theme) => theme.palette.stroke[100],
            "&:hover": {
                boxShadow: (theme) => theme.shadows.allAround,
            },
        } },
        React.createElement(AvatarGroup, { size: "xs" },
            React.createElement(ThumbnailAvatar, { src: bigGeoLogoPng }),
            React.createElement(ThumbnailAvatar, { src: discordLogoPng })),
        React.createElement(Stack, null,
            React.createElement(OverflowingTypography, { variant: "body4", fontWeight: "semibold", lineClamp: 2 }, "Join The BigGeo Discord Community"),
            React.createElement(OverflowingTypography, { variant: "body4", textColor: "disabled.onContainer", lineClamp: 3 }, "Be part of the conversation, get help from our team, and freely share your ideas. \uD83D\uDE80"))));
};
//# sourceMappingURL=DiscordIntegrationCard.js.map